// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer_257aA5n6e3ECWnvdqkSd4I"};